import { createContext, useContext } from 'react';

export const WizardContext = createContext(null);

export const useWizard = () => {
  const ctx = useContext(WizardContext);
  if (!ctx) throw new Error('useWizard must be used inside <Wizard>');
  return ctx;
};
